import React from 'react'

import { Button, ButtonVariant } from '@amzn/stencil-react-components/button'
import { Card } from '@amzn/stencil-react-components/card'
import { Chip, ChipBackgroundColor, ChipSize } from '@amzn/stencil-react-components/chip'
import { Row, Spacer, View } from '@amzn/stencil-react-components/layout'
import { H3, Text } from '@amzn/stencil-react-components/text'

export interface FormTemplateImportCardProps {
    actionsDisabled: boolean
    onExportSpreadsheet: () => void
    onStartImport: () => void
}

export function FormTemplateImportCard({
    actionsDisabled,
    onExportSpreadsheet,
    onStartImport,
}: FormTemplateImportCardProps) {
    return (
        <Card dataTestId='form-template-import-card'>
            <Row alignItems='center' justifyContent='space-between' gridGap='S300' width='100%'>
                <View>
                    <Chip backgroundColor={ChipBackgroundColor.Green} size={ChipSize.ExtraSmall}>
                        New
                    </Chip>
                    <Spacer height='S200' />
                    <H3 fontSize='T400'>
                        FormTemplate allows you to import content from a spreadsheet
                    </H3>
                    <Text fontSize='T100' color='neutral70'>
                        Import creates a new module and this one stays as your template.
                    </Text>
                </View>
                <Row alignItems='center' gridGap='S300'>
                    <Button
                        variant={ButtonVariant.Secondary}
                        aria-disabled={actionsDisabled}
                        onClick={onExportSpreadsheet}
                        dataTestId='export-spreadsheet-button'
                    >
                        Export spreadsheet
                    </Button>
                    <Button
                        variant={ButtonVariant.Primary}
                        aria-disabled={actionsDisabled}
                        onClick={onStartImport}
                        dataTestId='start-import'
                    >
                        Start import
                    </Button>
                </Row>
            </Row>
        </Card>
    )
}
